import React, { PropsWithChildren } from 'react';

type InputLabelWrapperProps = {
	labelName: string;
	col?: number;
	className?: string;
	flexDirection?: 'row' | 'column' | 'row-reverse' | 'column-reverse';
	hidden?: boolean;
};

const InputLabelWrapper: React.FC<PropsWithChildren<InputLabelWrapperProps>>  = props => {
	const { labelName, col, className, children, flexDirection, hidden = false } = props;
	if (hidden) return <></>;

	return (
		<div
			className={`flex flex-${flexDirection ?? 'column'} gap-1 mt-3 col-${
				col ?? 6
			} ${className}`}>
			<label>{labelName}</label>
			{children}
		</div>
	);
};

export default InputLabelWrapper;
